import {Injectable, signal} from '@angular/core';
import {ApiService} from './ApiService';
import {FormService} from './FormService';
import {AssignmentService} from './AssignmentService';

const allowed = [
  "date",
  "time",
  "textfield",
  "user_information",
  "branch_information",
  "calculated_field",
  "employees",
  "radio",
  "dropdown",
  "branches",
  "multiple_selection",
  "selected_employee_information"
];

interface ICachedDisplayFields {
  chain_id: number,
  branch_id: number,
  form_id: number,
  fields: IAvailableField[],
  changed: boolean
}

interface IAvailableField {
  id: number,
  name: string
}

@Injectable({providedIn: 'root'})
export class DisplayFieldsService {

  private formId: number = 0;

  public availableFields: IAvailableField[] = []

  public cached: ICachedDisplayFields[] = [];
  public fields: IAvailableField[] = []
  public loading = signal(false)

  constructor(
    private fsvc: FormService,
    private asvc: AssignmentService,
    private api: ApiService,
  ) {
  }

  Init(formId: number) {
    this.availableFields = []
    this.formId = formId;
    this.cached = []
    this.fields = []
  }

  private BuildAvailableFields() {
    this.availableFields = []
    this.fsvc.form_json.form_fields.forEach((ff: any) => {
      const nf = {
        id: Number(ff.field_id),
        name: ff.field_title
      };
      if (allowed.indexOf(ff.field_type) >= 0 && nf.name.trim() !== "") {
        this.availableFields.push(nf)
      }
    })
  }

  Load() {
    const chain_id = this.asvc.GetCurrentChainId()
    const branch_id = this.asvc.GetCurrentBranchId()

    if(!this.asvc.IsChainAssigned() || !this.asvc.IsBranchAssigned()) {
      return;
    }

    this.BuildAvailableFields();

    if (!chain_id && !branch_id) return;

    const i = this.cached.findIndex(lf => lf.chain_id == chain_id && lf.branch_id == branch_id);
    if(i >= 0) {
      this.fields = this.cached[i].fields;
      return;
    }

    this.loading.set(true);
    this.api.GetDisplayFields(this.formId, chain_id, branch_id).then(fields => {
      this.fields = []
      this.loading.set(false);
      fields.forEach(field => {
        this.fields.push(this.availableFields.find(af => af.id == field.field_id));
      })
      this.cached.push({
        chain_id,
        branch_id,
        form_id: this.formId,
        fields: this.fields,
        changed: false,
      });
    })
  }

  Sync() {
    const i = this.cached.findIndex(
      lf => lf.chain_id == this.asvc.GetCurrentChainId() && lf.branch_id == this.asvc.GetCurrentBranchId()
    );
    if(i >= 0) {
      this.cached[i].fields = this.fields
      this.cached[i].changed = true;
    }
  }

  Save() {
    this.cached.forEach(c => {
      if (c.changed) {
        this.api.SetDisplayFields(c.form_id, c.chain_id, c.branch_id, c.fields.map(f => f.id))
          .then(()=>c.changed = false)
      }
    })
  }
}
